import { useEffect, useState } from "react";
import { Play, X } from "lucide-react";
import Marquee from "./Marquee";
import { SIGNATURE_MOMENTS } from "../lib/media";

function MomentCard({ m, onOpen }) {
  return (
    <button onClick={() => onOpen(m)} data-testid={`moment-${m.youtubeId}`}
      className="gold-frame group relative w-[78vw] sm:w-[360px] aspect-[4/5] shrink-0 mr-4 overflow-hidden text-left snap-start">
      <img src={m.poster} alt={m.title} className="aperol absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-forest/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <span className="absolute top-4 right-4 w-11 h-11 rounded-full border border-white/70 flex items-center justify-center text-white"><Play size={16} /></span>
      <div className="absolute inset-x-0 bottom-0 p-6 text-ivory">
        <h3 className="font-headline text-2xl mt-1 leading-tight">{m.title}</h3>
        <p className="text-sm text-ivory/80 mt-2 leading-snug">{m.line}</p>
        {m.note && <p className="text-[0.7rem] italic text-ivory/65 mt-2 leading-snug">{m.note}</p>}
      </div>
    </button>
  );
}

export default function SignatureMoments() {
  const [open, setOpen] = useState(null);
  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") setOpen(null); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);
  const cards = SIGNATURE_MOMENTS.map((m) => <MomentCard key={m.youtubeId} m={m} onOpen={setOpen} />);
  return (
    <section id="signature-moments" className="py-16 border-t border-gold/40" data-testid="signature-moments">
      <div className="px-6 lg:px-10 max-w-7xl mx-auto mb-14">
        <p className="eyebrow mb-3">Past moments</p>
        <h2 className="font-display text-3xl lg:text-4xl tracking-tight leading-tight" data-testid="signature-heading">LUXEWELL <span className="font-sign lowercase text-gold tracking-normal text-4xl lg:text-5xl">signature</span> EXPERIENCES</h2>
        <p className="mt-4 font-headline text-xl text-ink/80"><em>Strategic Sabbaticals™</em> & <em>Regenerative Retreats™</em></p>
        <p className="mt-1 eyebrow !text-[0.6rem] !text-gold" data-testid="signature-dates">New Dates Coming Soon · <span className="whitespace-nowrap">By Application Only</span></p>
      </div>
      <Marquee duration={70} nonstop paused={!!open}>{cards}</Marquee>
      {open && (
        <div className="fixed inset-0 z-[70] bg-black/85 flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="moment-lightbox">
          <button onClick={() => setOpen(null)} aria-label="Close" data-testid="moment-close" className="absolute top-5 right-6 w-11 h-11 rounded-full border-2 border-[#E8D29B] bg-black/60 text-[#E8D29B] flex items-center justify-center hover:bg-[#E8D29B] hover:text-black transition-colors"><X size={22} /></button>
          <div className="w-full max-w-4xl aspect-video bg-black" onClick={(e) => e.stopPropagation()}>
            <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${open.youtubeId}?autoplay=1&rel=0`} title={open.title}
              allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
          </div>
        </div>
      )}
    </section>
  );
}
